import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Rating from '@dc/ui-library/src/molecules/Rating/Rating';
import CompareCheckbox from './CompareCheckbox.jsx';
import ProductChannelsAvailability from './ProductChannelsAvailability.jsx';
import ProductListingGridPriceBlock from './ProductListingGridPriceBlock.jsx';
import { createMarkup } from '../helpers.js';
import { showFlexibleCreditTooltip, hideFlexibleCreditTooltip }
  from '../../../../appState/ducks/listingPageProducts';
import ProductBriefDescriptionSwitch from './ProductBriefDescriptionSwitch.jsx';
import AddedValueMessagesListing from '../../AddedValueMessages/AddedValueMessagesListing';
import TariffDetails from '../../TariffDetails/TariffDetails';

class ProductsGridItem extends PureComponent {
  constructor(props) {
    super(props);

    this.onFlexibleTooltipClick = this.onFlexibleTooltipClick.bind(this);
  }

  componentDidUpdate() {
    if (this.props.shouldInformAboutUpdate) {
      this.props.gridItemUpdated();
    }
  }

  componentWillUnmount() {
    this.props.hideFlexibleCreditTooltip();
  }

  onFlexibleTooltipClick(e) {
    e.preventDefault();
    if (this.props.flexibleCreditTooltipProductID !== this.props.id) {
      this.props.setFlexibleAnchorRefToParent(this.flexibleAnchorRef);
      this.props.showFlexibleCreditTooltip(this.props.id);
    }
  }

  renderPromoMessages() {
    if (!this.props.promoMessages) {
      return <div className="promoMessages" />;
    }

    const promoMessages = this.props.promoMessages;
    const translations = this.props.translations;

    return (
      <div
        className="promoMessages"
        style={this.props.promoMessagesHeight
          ? { height: this.props.promoMessagesHeight }
          : undefined}
      >
        {promoMessages.isOnlineOnly &&
        <span className="label-online-only">
          {translations.onlineOnlyTranslation}
        </span>
        }

        {promoMessages.badges &&
        <p className="prd-stickers">
          {promoMessages.badges.map((sticker, i) => (
            <img
              key={i}
              src={sticker.src}
              alt={sticker.label}
              onLoad={() => {
                this.props.onImageLoaded();
              }}
              onError={() => {
                this.props.onImageLoaded();
              }}
            />))
          }
        </p>
        }

        {promoMessages.dealsAvailable &&
          <AddedValueMessagesListing
            view="grid"
            data={promoMessages.dealsAvailable}
          />
        }

        {promoMessages.marketingMessages &&
        <div className="rad">
          {promoMessages.marketingMessages.map((marketingMessage, i) => (
            <Fragment key={i}>
              <i className={`dcg-icon-${marketingMessage.class}`} />
              <strong>{marketingMessage.text}</strong>
            </Fragment>
          ))}
        </div>
        }
      </div>);
  }

  renderOnlineCredit() {
    return (
      <div
        ref={(ref) => { this.flexibleAnchorRef = ref; }}
        className="online-credit-message-wrapper"
        style={this.props.onlineCreditMessageWrapperHeight
          ? { height: this.props.onlineCreditMessageWrapperHeight }
          : undefined}
      >
        {this.props.onlineCreditLinkMessage &&
        <div
          className="online-credit-message"
          data-credit-available={this.props.isOnlineCreditAvailable ? true : undefined}
          data-credit-unavailable={this.props.isOnlineCreditAvailable ? undefined : true}
          onClick={e => this.onFlexibleTooltipClick(e)}
        >
          {this.props.onlineCreditLinkMessage}
        </div>
        }
      </div>
    );
  }

  renderTariffDetails() {
    return (
      <TariffDetails details={this.props.tariffDetails} />
    );
  }

  renderTariffAlternativeLink() {
    return (
      <div
        className="alternative-tariff-link-wrapper"
        style={this.props.alternativeTariffLinkWrapperHeight
          ? { height: this.props.alternativeTariffLinkWrapperHeight }
          : undefined}
      >
        {this.props.tariffAlternativeLink &&
        <div
          className="alternative-tariff-link"
        >
          <a href={this.props.tariffAlternativeLink.url}>
            {this.props.tariffAlternativeLink.label}
          </a>
        </div>
        }
      </div>
    );
  }

  render() {
    const { props } = this;
    const classes = ['product', 'result-prd'];

    if (props.stickerImage) {
      classes.push('stamped');
    }

    if (props.hasOurExpertsLoveTag) {
      classes.push('hero-product');
    }

    if (props.channelsAvailability.defaultAvailability.canBeDownloaded) {
      classes.push('download');
    }

    return (
      <article
        id={`product${props.id}`}
        className={classes.join(' ')}
        data-interaction={props.dataInteraction}
        data-fupid={props.dataInteraction ? props.id : undefined}
      >
        {props.hasOurExpertsLoveTag &&
          <strong className="label-expert">
            <div>{props.translations.ourExpertsLoveTranslation}</div>
          </strong>
        }

        <div className="productListImage">
          <a
            href={props.link}
            className={`imgC ${props.icons ? 'hasBadges' : ''}`}
          >
            <div
              className="product-images"
              style={props.productImagesHeight ? { height: props.productImagesHeight } : undefined}
            >
              {props.stickerImage &&
                <div className="sticker stickerImg">
                  <img
                    src={props.stickerImage.src}
                    alt={props.stickerImage.alt ? props.stickerImage.alt : undefined}
                  />
                </div>
              }
          
              <img
                className="image"
                src={props.image.src}
                alt={props.image.label}
                onLoad={() => {
                  props.onImageLoaded();
                }}
                onError={() => {
                  props.onImageLoaded();
                }}
              />
            </div>
          </a>
          {props.icons
            ? (
              <div
                className="badges desktop"
                style={props.iconsHeight ? { height: props.iconsHeight } : undefined}
              >
                {props.icons.map((badge, i) => (
                  <a
                    target="_blank"
                    href={badge.linkUrl ? badge.linkUrl : ''}
                    rel="noopener noreferrer"
                    key={i}
                  >
                    <img
                      src={badge.imgUrl}
                      alt=""
                      onLoad={(e) => {
                        props.onImageLoaded();
                      }}
                      onError={(e) => {
                        props.onImageLoaded();
                      }}
                    />
                  </a>
                ))}
              </div>
            )
            : (
              <a
                className="badges desktop"
                href={props.link}
                style={props.iconsHeight ? { height: props.iconsHeight } : undefined}
              >&nbsp;
              </a>
            )
          }
        </div>

        <div className="desc">
          <a className="in" href={props.link}>

            <div
              className="countdownLabels"
              style={props.countdownLabelsHeight
                ? { height: props.countdownLabelsHeight } : undefined}
            >
              {props.isFlashSale &&
                <div
                  className={'countdown-label ' +
                  `${props.countdownClassSuffix ? props.countdownClassSuffix : ''}`}
                  id={`countdown_${props.id}`}
                >
                  <p
                    dangerouslySetInnerHTML={
                      createMarkup(props.translations.countdownSaleTranslation)
                    }
                  />
                </div>
              }
            </div>

            <header className="productTitle">
              <span data-product="brand">{props.brand.title} </span>
              <span data-product="name">{props.title}</span>
            </header>

            <ul
              className="productBundle"
              style={props.productBundleHeight ? { height: props.productBundleHeight } : undefined}
            >
              {props.comboKitItemsNames && props.comboKitItemsNames.map((comboKitItemName, i) => (
                <li key={i} className="nowrap wide">
                  <i className="dcg-icon-plus" />
                  {comboKitItemName}
                </li>
              ))}
            </ul>

            <div
              className="reevoo-placeholder"
              style={props.reevooPlaceholderHeight
                ? { height: props.reevooPlaceholderHeight } : undefined}
            >
              {props.review && props.review.reviewCount > 0 &&
                <Rating
                  maxCount={5}
                  ratingCount={props.review.reviewCount}
                  ratingValue={props.review.score}
                />
              }
              {props.review && props.review.reviewCount === 0 &&
                <small>{props.translations.noReviewsTranslation}</small>
              }
            </div>

            {props.tariffDetails && this.renderTariffDetails()}

            {this.renderPromoMessages()}

            <ul
              className="productDescription"
              style={props.productDescriptionHeight
                ? { height: props.productDescriptionHeight } : undefined}
            >
              {props.descriptionBullets && props.descriptionBullets.map((description, i) =>
                (<li key={i}>{description}</li>))
              }
            </ul>

            <ProductListingGridPriceBlock
              isOutOfStock={props.isOutOfStock}
              isComboKit={Boolean(props.comboKitItemsNames)}
              isFlashSale={props.isFlashSale}
              price={props.price}
              translations={props.translations}
              productPricesHeight={props.productPricesHeight}
            />

            {this.renderOnlineCredit()}

            {this.renderTariffAlternativeLink()}

            <div
              className="countdownMessage"
              style={props.countdownMessageHeight
                ? { height: props.countdownMessageHeight } : undefined}
            >
              {props.isFlashSale &&
              <p className="countdownSticker">
                <strong
                  dangerouslySetInnerHTML={
                    createMarkup(props.translations.countdownSaleTranslation)}
                />
              </p>
              }
            </div>

            <ProductChannelsAvailability
              channelsAvailability={props.channelsAvailability}
              id={props.id}
              translations={props.translations}
              channelsAvailabilityHeight={props.channelsAvailabilityHeight}
            />
          </a>

          <ProductBriefDescriptionSwitch
            productID={props.id}
            withArrow
            productDescHeight={props.productDescHeight}
          />

          {props.displayCompare &&
            <CompareCheckbox
              containerFormEl={document.querySelector('form[data-component="compareForm"]')}
              product={props}
              tooltipArrowDirection="top"
              tooltipTextTranslate={props.translations.tooltipTextTranslate}
            />
          }
        </div>
      </article>
    );
  }
}

ProductsGridItem.displayName = 'ProductsGridItem';

ProductsGridItem.propTypes = {
  icons: PropTypes.arrayOf(
    PropTypes.shape({
      imgUrl: PropTypes.string.isRequired,
      linkUrl: PropTypes.string
    })
  ),
  channelsAvailability: PropTypes.shape({
    defaultAvailability: PropTypes.shape({
      canBeDownloaded: PropTypes.bool
    })
  }).isRequired,
  comboKitItemsNames: PropTypes.arrayOf(PropTypes.string),
  comboKitNumberOfItemsMessage: PropTypes.string,
  countdownClassSuffix: PropTypes.string,
  displayCompare: PropTypes.bool.isRequired,
  deviceType: PropTypes.string.isRequired,
  flexibleCreditTooltipProductID: PropTypes.string,
  hasOurExpertsLoveTag: PropTypes.bool.isRequired,
  hideFlexibleCreditTooltip: PropTypes.func,
  isFlashSale: PropTypes.bool.isRequired,
  isOnlineCreditAvailable: PropTypes.bool,
  isOutOfStock: PropTypes.bool.isRequired,
  onlineCreditLinkMessage: PropTypes.string,
  tariffAlternativeLink: PropTypes.shape({
    url: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  }),
  brand: PropTypes.shape({
    title: PropTypes.string.isRequired
  }).isRequired,
  descriptionShortened: PropTypes.string.isRequired,
  descriptionBullets: PropTypes.arrayOf(
    PropTypes.string
  ),
  id: PropTypes.string.isRequired,
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  }).isRequired,
  title: PropTypes.string.isRequired,
  price: PropTypes.shape({}).isRequired,
  link: PropTypes.string.isRequired,
  promoMessages: PropTypes.shape({
    isOnlineOnly: PropTypes.bool.isRequired,
    marketingMessages: PropTypes.arrayOf(PropTypes.shape({
      class: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired
    }).isRequired),
    numberOfDealsAvailableTranslation: PropTypes.string,
    badges: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      src: PropTypes.string.isRequired
    }))
  }).isRequired,
  review: PropTypes.shape({
    reviewCount: PropTypes.number.isRequired,
    score: PropTypes.number
  }),
  showFlexibleCreditTooltip: PropTypes.func,
  stickerImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string
  }),
  translations: PropTypes.shape({
    countdownSaleSearchTranslation: PropTypes.string.isRequired,
    countdownSaleTranslation: PropTypes.string.isRequired,
    noReviewsTranslation: PropTypes.string.isRequired,
    ourExpertsLoveTranslation: PropTypes.string.isRequired,
    onlineOnlyTranslation: PropTypes.string.isRequired,
    tooltipTextTranslate: PropTypes.string.isRequired
  }).isRequired,
  // Following props only solves dynamic resizing of component's parts
  productImagesHeight: PropTypes.number,
  iconsHeight: PropTypes.number,
  countdownLabelsHeight: PropTypes.number,
  productBundleHeight: PropTypes.number,
  reevooPlaceholderHeight: PropTypes.number,
  promoMessagesHeight: PropTypes.number,
  productDescriptionHeight: PropTypes.number,
  productPricesHeight: PropTypes.number,
  onlineCreditMessageWrapperHeight: PropTypes.number,
  alternativeTariffLinkWrapperHeight: PropTypes.number,
  countdownMessageHeight: PropTypes.number,
  channelsAvailabilityHeight: PropTypes.number,
  productDescHeight: PropTypes.number,
  shouldInformAboutUpdate: PropTypes.bool, // TODO: choose better name ASA it's working
  onImageLoaded: PropTypes.func,
  gridItemUpdated: PropTypes.func, // TODO: choose better name ASA it's working
  setFlexibleAnchorRefToParent: PropTypes.func,
  dataInteraction: PropTypes.string,
  onProductIntersection: PropTypes.func,
  tariffDetails: PropTypes.shape({
    data: PropTypes.objectOf(PropTypes.string),
    minutes: PropTypes.objectOf(PropTypes.string),
    texts: PropTypes.objectOf(PropTypes.string)
  })
};

ProductsGridItem.defaultProps = {
  icons: undefined,
  comboKitItemsNames: undefined,
  comboKitNumberOfItemsMessage: undefined,
  countdownClassSuffix: undefined,
  onlineCreditLinkMessage: undefined,
  tariffAlternativeLink: null,
  descriptionBullets: undefined,
  review: undefined,
  stickerImage: undefined,
  flexibleCreditTooltipProductID: null,
  showFlexibleCreditTooltip: () => {},
  hideFlexibleCreditTooltip: () => {},
  productImagesHeight: undefined,
  iconsHeight: undefined,
  isOnlineCreditAvailable: false,
  countdownLabelsHeight: undefined,
  productBundleHeight: undefined,
  reevooPlaceholderHeight: undefined,
  promoMessagesHeight: undefined,
  productDescriptionHeight: undefined,
  productPricesHeight: undefined,
  onlineCreditMessageWrapperHeight: undefined,
  alternativeTariffLinkWrapperHeight: undefined,
  countdownMessageHeight: undefined,
  channelsAvailabilityHeight: undefined,
  productDescHeight: undefined,
  shouldInformAboutUpdate: false,
  onImageLoaded: () => {},
  gridItemUpdated: () => {},
  setFlexibleAnchorRefToParent: () => {},
  dataInteraction: undefined,
  onProductIntersection: undefined,
  tariffDetails: undefined
};

const mapStateToProps = state => ({
  flexibleCreditTooltipProductID: state.listingPage.products.flexibleCreditTooltipProductID,
  deviceType: state.general.device.deviceType
});

const dispatchFunctions = {
  showFlexibleCreditTooltip,
  hideFlexibleCreditTooltip
};

export default connect(mapStateToProps, dispatchFunctions)(ProductsGridItem);
